module.exports = __webpack_public_path__ + "img/drone.269a1acc.svg";